export default __webpack_public_path__ + "static/media/banners_11.86247391.png";